import calcio from '../assets/HeroMcare.webm';
import LogoAnimation from '../components/logo/logoAnimation';
import { useEffect, useRef, useState } from 'react';


const Hero = ({ handleClickForm }) => {
    const videoRef = useRef(null);
    const [width, setWidth] = useState(window.innerWidth);

    // Removes the static #hero-loader overlay defined in public/index.html.
    // Skipped during the react-snap prerender (its userAgent is "ReactSnap")
    // so the loader stays baked into the static HTML and shows on first paint.
    const hideLoader = () => {
        if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') return;
        const el = document.getElementById('hero-loader');
        if (el) {
            el.classList.add('hero-loader--hidden');
            setTimeout(() => el.remove(), 700);
        }
    };

    // Fire when playback actually starts (not just when the first frame is
    // decoded), so the loader stays up until the video is really running.
    const handlePlaying = () => hideLoader();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // Fallback: if the video is already playing (e.g. from cache) before the
    // event listeners attach, or takes too long, don't block the UI forever.
    useEffect(() => {
        const video = videoRef.current;
        if (video && video.readyState >= 3 && !video.paused) {
            hideLoader();
        }
        const timeout = setTimeout(hideLoader, 10000);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        const video = videoRef.current;

        if (video) {
            video.muted = true;

            const playPromise = video.play();

            if (playPromise !== undefined) {
            playPromise.catch((error) => {
                console.log("Autoplay bloccato:", error);
            });
            }
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
          setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
      <section data-aos="fade-in" data-aos-duration="2000" className='mx-auto'>
            <div className='h-screen flex justify-center items-center relative'>
              {/* Video Background */}
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                onPlaying={handlePlaying}
                className="absolute object-right w-full h-full object-cover -z-10 opacity-30 xl:hidden block"
                src={calcio}
                type="video/webm"
              ></video>

              {/* Content */}
              <div className="absolute top-0 left-0 h-full sm:w-3/4 xl:w-1/2 flex justify-center items-center p-4 z-20">
                <div className='absolute top-0 left-0 h-full w-full xl:bg-black opacity-60'></div>
                <div className="text-left w-full xl:max-w-3xl mx-auto mb-36 xl:mb-14 sm:mb-0 z-20 xl:pl-28">
                  <LogoAnimation percentage={width < 420 ? 100 : 125} />
                  <div className="flex justify-start items-center w-full me-0 sme-2">
                    <h1
                      className="text-3xl xl:text-4xl text-white font-medium"
                      data-aos="fade-right"
                      data-aos-duration="2000"
                    >
                      Dove la Riabilitazione diventa Performance
                    </h1>
                  </div>
                  <div
                    data-aos="fade-right"
                    data-aos-duration="2500"
                    className="mb-10 mt-5 font-medium sm:ms-0 text-white text-balance"
                  >
                    <p className="font-normal text-xl xl:text-2xl">
                      Diamo nuova Vita al tuo Movimento
                    </p>
                  </div>
                  <button
                    onClick={handleClickForm}
                    id="heroSection"
                    // className="px-8 py-2 w-full xl:w-2/3 progress-button-mcare text-white"
                    className="mt-4 progress-button-mcare px-8 py-4 text-center w-full lg:w-fit"
                  >
                    Prenota una consulenza
                  </button>
                  {/* <a
                      href="#formContatti"
                      className="progress-button-mcare px-8 py-4 uppercase font-semibold tracking-wider text-center transition duration-300 ease-in-out w-full lg:w-2/3 ">
                      Prenota una consulenza
                  </a> */}
                </div>
              </div>

              <div className='opacity-80 h-full w-full hidden xl:block z-0 relative'>
                <video
                ref={videoRef}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  onPlaying={handlePlaying}
                  className="h-full w-full object-cover lg:opacity-90 opacity-50"
                  style={{ transform: 'scale(1)' }}
                  alt="background video">
                  <source src={calcio} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
                <svg className="absolute inset-y-0 left-[50%] w-[11.5rem] h-full opacity-60" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <polygon points="0,0 100,0 0,100" fill="currentColor" />
                </svg>
              </div>
            </div>

      </section>
    );
}

export default Hero;
